import React from 'react';

interface LabelProps {
  htmlFor?: string;
  label?: string;
}

export const Label: React.FC<LabelProps> = ({ htmlFor, label }) => {
  if (!label) return null;
  return (
    <label className="label-v2" htmlFor={htmlFor}>
      {label}
      <span className="required-star">*</span>
    </label>
  );
};
